var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"one-sidebar",class:{ 'show': _vm.showActionMenu }},[_c('one-base-home-page',{staticClass:"mx-0 flex-column h-100"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showActionMenu),expression:"showActionMenu"}],staticClass:"one-sidebar__element"},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }